export function hexToRgb(hex) {
    if (hex) {
        let H = hex.replace('#', '')
        let R = parseInt(`${H[0]}${hex[1]}`, 16)
        let G = parseInt(`${H[2]}${H[3]}`, 16)
        let B = parseInt(`${H[4]}${H[5]}`, 16)

        return { red: R, green: G, blue: B }
    }
}

export function useWhiteTextHex(hex) {
    if (hex) {
        let rgb = hexToRgb(hex)

        return useWhiteTextRgb(rgb.red, rgb.green, rgb.blue)
    }
}

export function useWhiteTextRgb(R, G, B) {
    let C
    let L

    C = [R / 255, G / 255, B / 255]

    for (var i = 0; i < C.length; ++i) {
        if (C[i] <= 0.03928) {
            C[i] = C[i] / 12.92
        } else {
            C[i] = Math.pow((C[i] + 0.055) / 1.055, 2.4)
        }
    }

    L = 0.2126 * C[0] + 0.7152 * C[1] + 0.0722 * C[2]

    // if (L > 0.179) {
    if (L > 0.479) {
        return false
    } else {
        return true
    }
}
